import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment-timezone';
import { Card, Row, Col, Popover } from 'antd';
import { QuestionCircleOutlined,DownloadOutlined } from '@ant-design/icons';
import ReactECharts from 'echarts-for-react';
import help from '../../config/help.json';
import { CSVLink } from 'react-csv';

import './analytics.css';



var cc_data2;

// const countriesInfo = Object.keys(countrycodeLatlong).map(code =>({code, lat:countrycodeLatlong[code][0], long:countrycodeLatlong[code][1], name: countries[code.toUpperCase()]}))

class NewUsersCard extends Component {
	constructor(props) {
		super(props);
		this.state = {
		}
	}

	async componentDidUpdate(prevProps) {
	}

	// renameAppName(value){
		
	// 	switch(value){
	// 		case "Vivamax" :
	// 			return "Android Vivamax";
	// 		case "Viva One" :
	// 			return "Android Vivaone";
	// 		case "Viva STORE" :
	// 			return "iOS Vivamax";
	// 		case "Vivaone STORE" :
	// 			return "iOS Vivaone";
	// 		default:
	// 			return value;
	// 	}

	// }
	render() {
		const {  loading, userTheme, opensearchDailyNewUserByAppnameList } = this.props;

		// cc_data = opensearchDailyNewUserList || [];
		// cc_data = cc_data.sort((a, b) => a.key - b.key);
		//cc_data1 = opensearchDailyActiveUserList || [];
		cc_data2 = opensearchDailyNewUserByAppnameList || [];
		cc_data2 = cc_data2.sort((a, b) => a.key - b.key);
		cc_data2.forEach((c,d)=>{
			cc_data2[d].key_as_string = moment(c.key_as_string).format("MMM-DD")
		})

		let appnames = [];
		let seriesarray = [];
		let totalcount = [];

		if (cc_data2 && cc_data2[0] && cc_data2[0].appnames && cc_data2[0].appnames.buckets) {
			appnames = cc_data2[0].appnames.buckets;
			appnames.forEach((d) => {
				let appnamecount = [];
				cc_data2.forEach((c) => {
					let doccount = c.appnames.buckets.filter(f => f.key === d.key);
					appnamecount.push(doccount.length > 0 ? doccount[0].doc_count : 0);
					totalcount.push(c.doc_count);
				})
				// seriesarray.push({ name: this.renameAppName(d.key), type: 'line',  data: appnamecount });
				seriesarray.push({ name: d.key, type: 'line',  data: appnamecount });
			})
			seriesarray.push({ name: 'total', type: 'line', data: totalcount });
		}

		const options = {
			
			tooltip: {
				trigger: 'axis'
			},
			legend: {
				data: appnames.map(d => d.key),
				// data: appnames.map(d => this.renameAppName(d.key)),
				top: '7%',
				type: 'scroll',
			},
			grid: {
				left: '3%',
				right: '4%',
				bottom: '3%',
				containLabel: true
			},
			// toolbox: {
			// 	showTitle: false,
			// 	feature: {
			// 		mark: { show: true },
			// 	dataView: { show: true, readOnly: false, lang:['Data View', 'Close', 'Refresh'],title:'Data View' },
			// 	magicType: { show: true, type: ['line', 'bar', 'stack'],title:{line:'Line Chart', bar:'Bar Chart',stack:'Stack Chart',tiled:'Tiled Chart' }},
			// 	restore: { show: true, title:'Refresh' },
			// 	}
			// },
			xAxis: {
				type: 'category',
				data: cc_data2.map(d => d.key_as_string),
				axisTick: {
					show: false
				},
				axisLabel: {
					//interval: 7,
					formatter: function (timestamp) {
						return moment(new Date(timestamp)).format("MMM-DD");
					}
				},
				axisLine: {
					lineStyle: {
						type: 'solid'
					}
				}
			},
			yAxis: {
				type: 'value'
			},
			series: seriesarray
			// [
			//   {
			// 	name: 'Vivamax',
			// 	type: 'line',
			// 	stack: 'Total',
			// 	data: cc_data.map(d=>d.newusers.value)
			//   },
			//   {
			// 	name: 'Viva One',
			// 	type: 'line',
			// 	stack: 'Total',
			// 	data: cc_data1.map(d=>d.activeusers.value)
			//   }
			// ]
		};

		// const options = {
		// 			backgroundColor: (userTheme === 'dark')?"#00000080":"#FFFFFF80",
		// 			grid: {
		// 				top: '10%',
		// 		    left: '2%',
		// 		    right: '2%',
		// 		    bottom: '0%',
		// 				containLabel: true },
		// 			xAxis: {
		// 				type: 'category',
		// 				data: cc_data.map(d=>d.key_as_string),
		// 				axisTick: {
		// 					show: false
		// 				},
		// 				axisLabel: {
		// 					interval: 7,
		// 					formatter: function (timestamp) {
		// 						return moment(timestamp).format("MMM-DD");
		// 					}
		// 				},
		// 				axisLine: {
		// 					lineStyle: {
		// 						type: 'solid'
		// 					}
		// 				}
		// 			},
		// 		  yAxis: {
		// 		    type: 'value',
		// 	      splitArea: {
		// 	        show: true
		// 	      },
		// 				axisLine: {
		// 					lineStyle: {
		// 						type: 'solid'
		// 					}
		// 				}
		// 		  }
		// 		};

		// let options1 = Object.assign({}, options, {
		// 	    tooltip: {
		// 	      trigger: 'axis',
		// 				formatter: function (data) {
		// 					data = data[0];
		// 					return `New User:<br> ${cc_data[data.dataIndex].newusers.value} @ ${moment(cc_data[data.dataIndex].key_as_string).format("MMM-DD")} `
		// 				},
		// 				rich: {}
		// 	    },
		// 		  series: [
		// 		    {
		// 		      data: cc_data.map(d=>d.newusers.value),
		// 		      type: 'line',
		// 					color: '#096dd9',
		// 			showSymbol: false
		// 		    },
		// 			{
		// 				data: cc_data1.map(d=>d.activeusers.value),
		// 				type: 'line',
		// 					  color: '#096787',
		// 			  showSymbol: false
		// 			  }
		// 		  ]
		// 		});
		let csv_data = [];
		cc_data2.forEach( (c,i)=> {
			seriesarray.forEach(d => {
				if(d){
					csv_data.push({date : c.key_as_string, platforms : d.name , count : d.data[i]})
				}
			})
		})
		return (
			<Card className="analyticCard analyticActiveUsersCard">
				<h3 className="title">{`New Users  `}
				<Popover placement="topLeft"
						overlayStyle={{width:'300px'}}
						content= {help.find(d=> d.name ==='NewUsersCard').en}
						trigger="click"><QuestionCircleOutlined />
					</Popover>
					<CSVLink data={csv_data} target="_blank" filename={"New Users.csv"}>
						<DownloadOutlined />
					</CSVLink>
				</h3>
				<Row>
					<Col span={24}>
						<ReactECharts style={{ height: 320, width: '100%' }} theme={userTheme} option={options} notMerge={true} showLoading={loading} loadingOption={{ color: "#74add1" }} />
					</Col>
				</Row>
			</Card>
		);
	}


}

const mapStateToProps = state => ({
	router: state.router,
	userTheme: state.user.userTheme,
	opensearchDailyNewUserList: state.analytics.opensearchDailyNewUserList,
	selectedOrganization: state.user.selectedOrganization,
	opensearchDailyActiveUserList: state.analytics.opensearchDailyActiveUserList,
	opensearchDailyNewUserByAppnameList: state.analytics.opensearchDailyNewUserByAppnameList
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
		},
		dispatch
	);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NewUsersCard));
